import React from 'react'
import TableContent from '../../components/TableContent'
const url = 'connector/onedrive-share'
const item = 'OneDrive Share'
const items = 'OneDrive Shares'

const ConnectorOneDriveShare = () => {
  return <TableContent url={url} type={'connector-onedrive-share'} item={item} items={items} />
}
export default ConnectorOneDriveShare
